import React from 'react'
import { IProps } from './index'
import EditorialWrapItem from './item'
import styles from './style.scss'
import classnames from 'classnames'
import { useSpacing } from 'marketing-site/src/library/providers/spacingProvider'
import { ColorName, getColorTheme, Color } from 'marketing-site/src/library/utils'

export function EditorialWrap({ sidebar, content, backgroundColor }: IProps): React.ReactElement {
  const spacing = useSpacing()
  const colorTheme = getColorTheme('default', backgroundColor)
  const wrapClasses = classnames('editorial-wrap__section', {
    [`editorial-wrap__section--${ColorName[colorTheme.id as Color]}`]: backgroundColor,
    'editorial-wrap__section--padding': !spacing,
  })
  return (
    <div className={wrapClasses}>
      <div className="editorial-wrap">
        <div className="editorial-wrap__sidebar">
          {sidebar.map((item, i) => item && <EditorialWrapItem key={i} {...item} />)}
        </div>
        <div className="editorial-wrap__content">
          {content.map((item, i) => item && <EditorialWrapItem key={i} {...item} />)}
        </div>
      </div>
      <style jsx>{styles}</style>
      <style jsx>{`
        .editorial-wrap__section {
          background-color: ${colorTheme.backgroundColor};
          color: ${colorTheme.textColor};
        }
      `}</style>
    </div>
  )
}
